import { useContext, useEffect, useState } from 'react';
import { Auth } from '../StateManagment/Auth';
import { useFirestoreNoCompagny } from '../firebase/useFirestore';

const SuperAdmin = () => {
    const [authO] = useContext(Auth)
    const [admin, setAdmin] = useState(false)

    const superAdmins = useFirestoreNoCompagny('Users', 'SuperAdmin', true)

    useEffect(() => {
        superAdmins && superAdmins.map(admin => {
            if (admin.ID === authO?.ID) {
                setAdmin(true)
            }
        })
    }, [superAdmins, authO])


  return (
    {admin}
  )
}

export default SuperAdmin